
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getAvoidLoginUrl, getFinanceInfo ,FinanceInfo } from "@/api/iousServices";
import { openFDWhitePage } from '@/utils/h5ToApp'
import dayjs from 'dayjs'
let toObject = require('dayjs/plugin/toObject')
dayjs.extend(toObject)
@Component({
  name: 'withePay',
})
export default class withePay extends Vue {
  @Getter info: any // 用户信息
  @Getter userId!: string
  @Getter mobile!: string
  @Getter whiteStrips!: number
  @Prop({default:''}) whiteSignTime!:string
  @Prop({default:''}) endSignTime!:string

  show = false
  statusText = ''
  whiteInfo:FinanceInfo = {}
  dateVal: {[x:string]:any} = {}

  @Watch('show')
  onShowResultChange() {
    this.changeNativeAreaColor(this.show)
  }

  created() {
    console.log('whiteStrips',this.whiteStrips);
    this.getFinanceInfo()

  }
  /**
   * whiteStrips 白条权限状态
   * 1 已开通，可以正常进入
   * 2 公司未完成企业认证，跳转至企业认证、
   * 3 需个人实名认证
   * 4 未开通，但有开通权限
   * 5 没有相关权限
   */
  approveConfirm() {
    switch (this.whiteStrips) {
      case 2:
          window.localStorage.setItem('FDWhite', '1')
          window.localStorage.setItem('isFinance', '1')
          this.$router.push({
            path: '/companyInfoForm',
            query: {
              formPage: 'h5'
            }
          })
        break
      case 3:
          window.localStorage.setItem('FDWhite', '1')
          window.localStorage.setItem('isFinance', '1')
          this.$router.push({
            path: '/userInfoForm',
            query: {
              formPage: 'h5'
            }
          })
        break
      case 5:
          this.$router.push({
            path: '/userInfoForm',
            query: {
              formPage: 'h5'
            }
          })
        break
    }
    this.show = false
  }
  /**
   * 工作台获取白条信息
   */
  getFinanceInfo() {
    const params = {
      companyId: this.info.companyId
    }
    getFinanceInfo(params).then((res) => {
      this.whiteInfo = res.data
      // @ts-ignore
      this.dateVal = dayjs(res.data.nowTime).toObject()
    })
  }
  /**
   * @description 白条快付
   */
  withePay() {
    // console.log('supplementInfo', this.whiteStrips)
    this.getAuthority()
  }
    // 1还款入口 2授信入口 3借款入口
  fdfreeLogin(flag = '') {
    let params = {
      companyId: this.info.companyId,
      webShow: flag
    }
    getAvoidLoginUrl({ ...params })
      .then((res) => {
        const { code, data } = res
        if (code === '000000') {
          let encodeUrl = encodeURI(data.responseData.redirectUrl)
          let isQuery = encodeUrl.indexOf('?') > -1
          let url = `${encodeUrl}${
            isQuery ? '&' : '?'
          }webShow=${flag}&userPhone=${this.mobile}&cykjSource=homes` //+ (flag == '' ? `&companyName=${this.companyName}` : '')
          openFDWhitePage({ url })
        }
      })
      .catch((e) => {
        if (e.message !== '取消重复请求') this.$toast('请先绑定版本码')
      })
  }

  getAuthority() {
    switch (this.whiteStrips) {
      case 2:
        this.statusText = '开通金融服务需完成企业认证'
        this.show = true
        // this.$dialog
        //   .confirm({
        //     message: '开通金融服务需完成企业认证',
        //     confirmButtonText: '去认证',
        //     cancelButtonText: '取消认证'
        //   })
        //   .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            // window.localStorage.setItem('FDWhite', '1')
            // window.localStorage.setItem('isFinance', '1')
            // this.$router.push({
            //   path: '/companyInfoForm',
            //   query: {
            //     formPage: 'h5'
            //   }
            // })
          // })
          // .catch(() => {})
        break
      case 3:
        this.statusText = '开通金融服务需完成个人身份认证，且身份为持股比例大于5%的股东'
        this.show = true
        // this.$dialog
        //   .confirm({
        //     message:
        //       '开通金融服务需完成个人身份认证，且身份为持股比例大于5%的股东',
        //     confirmButtonText: '去认证',
        //     cancelButtonText: '取消认证'
        //   })
        //   .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            // window.localStorage.setItem('FDWhite', '1')
            // window.localStorage.setItem('isFinance', '1')
            // this.$router.push({
            //   path: '/userInfoForm',
            //   query: {
            //     formPage: 'h5'
            //   }
            // })
          // })
          // .catch(() => {})
        break
      case 5:
        this.statusText = '当前账号不符合金融服务开通条件，需企业法人或持股比例大于5%股东才可开通，若您身份已变更，可前往身份认证进行修改'
        this.show = true
        // this.$dialog
        //   .confirm({
        //     message:
        //       '当前账号不符合金融服务开通条件，需企业法人或持股比例大于5%股东才可开通，若您身份已变更，可前往身份认证进行修改',
        //     confirmButtonText: '去认证',
        //     cancelButtonText: '取消认证'
        //   })
        //   .then(() => {
            // this.$router.push({
            //   path: '/userInfoForm',
            //   query: {
            //     formPage: 'h5'
            //   }
            // })
          // })
          // .catch(() => {})
        break
      case 1:
      case 4:
        // 是否签署授权书
        this.statusText = ''
        if (
          window.localStorage.getItem('isSign') == '1' &&
          this.whiteSignTime < this.endSignTime
        ) {
          this.fdfreeLogin()
        } else {
          window.localStorage.removeItem('isSign')
          this.$router.push({
            path: '/iousAuthorize',
            query: {
              cykjSource: 'homes'
            }
          })
        }
        break
    }
  }

  changeNativeAreaColor (isShow: boolean) {
    const params = {
      statusBarColor: isShow ? '000000' : 'DCE9F9',  // 状态栏颜色
      bottomColor: isShow ? '000000' : 'FFFFFF', // 底部安全区颜色
      alpha: isShow ? 0.7 : 1
    }
    this.$bridge.callHandler('changeNativeAreaColor', params, (res) => {
    })
  }
}
